import { useEffect } from 'react';

import { useScrollIntoView } from 'shared/hooks/dom';

import type { Message } from 'pages/ParentHelper/types';
import type { RefObject } from 'react';

export const useScrollToChatsBottom = <Ref extends RefObject<HTMLElement>>(
  ref: Ref,
  data: Message[],
  shouldScrollToBottom = true,
) => {
  const scrollIntoView = useScrollIntoView(ref);

  useEffect(() => {
    if (!shouldScrollToBottom || !data) return;

    scrollIntoView();
  }, [data, shouldScrollToBottom, scrollIntoView]);
};
